import { makeStyles } from '@material-ui/core'

const styles = (width = 158) =>
  makeStyles(() => ({
    chipCell: {
      width,
      display: 'flex',
      justifyContent: 'center',
    },
  }))

export default styles
